export const TIENDANUBE_INTEGRATION_CLASS = 'TiendanubeCustom';
